// Reconstructed from production code; original paths and local names were not available.
const translations = {
  ar: {
    home: "الرئيسية",
    shop: "المتجر",
    manasek: "التصنيفات",
    partners: "شركاؤنا",
    admin: "لوحة التحكم",
    logout: "تسجيل الخروج",
    cartTitle: "سلة التسوق",
    cartCount: "منتج في السلة",
    cartEmpty: "سلتك فارغة",
    cartBrowse: "تصفح الكتالوج واختر المنتجات التي تحتاجها.",
    remove: "حذف",
    total: "المجموع",
    checkout: "إتمام الطلب",
    updatingCart: "جاري تحديث السلة...",
    heroTitle: "كل منتجاتك في كتالوج واحد منظم",
    heroSubtitle:
      "تصفح منتجات متعددة حسب التصنيفات، قارن التفاصيل، وأرسل طلبك بسهولة.",
    discoverOurProducts: "اكتشف منتجاتنا",
    shopNow: "تسوّق الآن",
    manasekProducts: "كل المنتجات",
    ourStory: "طريقة عملنا",
    ourStoryTitle: "كتالوج مرن لمنتجات متعددة",
    ourStoryDesc:
      "صممنا الواجهة لتخدم أي نوع من المنتجات: تصنيفات واضحة، بطاقات منظمة، تفاصيل دقيقة، وتجربة طلب مباشرة من غير ربط الموقع بثيمة واحدة.",
    categories: "التصنيفات",
    categoriesDesc:
      "اختر تصنيفاً للاطّلاع على المنتجات والخيارات المتوفرة داخله.",
    allProducts: "جميع المنتجات ←",
    viewCategory: "عرض التصنيف",
    viewAll: "عرض الكل",
    newArrivals: "أحدث منتجاتنا",
    featuredProducts: "منتجات مختارة",
    featuredDesc: "منتجات مختارة من الكتالوج حسب آخر الإضافات والتوفر.",
    viewStore: "عرض المتجر ←",
    ourPromise: "وعدنا",
    ourPromiseTitle: "تجربة منظمة مهما كان نوع المنتج",
    ourPromiseDesc:
      "كل صفحة مصممة لتعرض المنتجات بوضوح: صور، أسعار، خيارات، وتفاصيل تساعد العميل على الاختيار بسرعة.",
    discoverCollection: "اكتشف المجموعة الكاملة",
    filters: "التصنيفات",
    minPrice: "السعر الأدنى",
    maxPrice: "السعر الأقصى",
    applyFilters: "تطبيق التصفية",
    resetFilters: "إعادة تعيين",
    addToCart: "أضف إلى السلة",
    loadingProducts: "جاري تحميل المنتجات...",
    noProducts: "لم يتم العثور على منتجات مطابقة.",
    sale: "تخفيض",
    searchPlaceholder: "ابحث عن منتج...",
    allCategories: "جميع الفئات",
    inStock: "في المخزن",
    outOfStock: "غير متوفر",
    quantity: "الكمية",
    description: "الوصف",
    specifications: "المواصفات",
    size: "الحجم",
    priceOMR: "ريال عماني",
    relatedProducts: "منتجات ذات صلة",
    videoPresentation: "عرض بالفيديو",
    checkoutTitle: "إتمام عملية الشراء",
    personalInfo: "المعلومات الشخصية",
    fullName: "الاسم الكامل",
    phone: "رقم الهاتف",
    email: "البريد الإلكتروني",
    address: "العنوان",
    city: "المدينة",
    notes: "ملاحظات الطلب (اختياري)",
    paymentMethod: "طريقة الدفع",
    cashOnDelivery: "الدفع عند الاستلام",
    creditCard: "بطاقة الائتمان",
    orderSummary: "ملخص الطلب",
    placeOrder: "تأكيد الطلب",
    subtotal: "المجموع الفرعي",
    discount: "الخصم",
    shipping: "الشحن",
    free: "مجاني",
    orderSuccess: "تم تسجيل طلبك بنجاح!",
    orderSuccessDesc:
      "شكراً لثقتكم بنا. سنتصل بكم لتأكيد الطلب وتفاصيله في أقرب وقت.",
    backToHome: "العودة للرئيسية",
    adminTitle: "لوحة التحكم",
    adminDashboard: "لوحة القيادة",
    adminProducts: "المنتجات",
    adminCaisse: "صندوق البيع",
    adminCategories: "الفئات",
    adminCommandes: "الطلبات",
    adminClients: "العملاء",
    adminUsers: "المستخدمون",
    adminPaniers: "السلال",
    adminPartners: "الشركاء",
    adminAppearance: "المظهر والسلايدر",
    adminFooter: "التذييل",
    adminVisits: "إحصاءات الزيارات",
    dashboardPerformance: "أداء المتجر",
    dashboardSubtitle: "تم قبول {accepted} طلب من إجمالي {total} طلب.",
    dashboardConfirmedRevenue: "الإيرادات المؤكدة",
    dashboardAcceptanceRate: "معدل القبول",
    dashboardThisMonth: "هذا الشهر",
    dashboardMostDemanded: "المنتج الأكثر طلباً",
    dashboardPiecesRequested: "{count} قطع مطلوبة",
    dashboardPendingPotential: "العائدات المعلقة",
    dashboardWaitingOrders: "{count} طلب قيد الانتظار",
    dashboardAcceptedOrders: "{count} طلب مقبول",
    dashboardTotalOrders: "إجمالي الطلبات",
    dashboardRefused: "مرفوض",
    dashboardDemandedPieces: "القطع المطلوبة",
    dashboardActiveProductsCount: "{count} منتجات نشطة",
    dashboardOrderStatus: "حالة الطلبات",
    dashboardStatusSub: "الإيرادات وحجم الطلبات حسب الحالة.",
    dashboardRecentOrders: "آخر الطلبات",
    dashboardRecentActivity: "النشاط الأخير.",
    dashboardNoRecentOrders: "لا توجد طلبات حديثة.",
    dashboardProductPerf: "أداء المنتجات",
    dashboardProductPerfSub: "الإيرادات المقبولة، الإيرادات المعلقة، والطلب.",
    dashboardSearchPlaceholder: "البحث عن منتج...",
    dashboardSold: "مباع",
    dashboardRequested: "مطلوب",
    dashboardPending: "معلق",
    dashboardRevenue: "الإيرادات",
    dashboardDemand: "الطلب",
    dashboardNoProductAnalytics: "لم يتم العثور على تحليلات المنتج.",
    dashboardRecentOrdersTable: "الطلبات الأخيرة",
    dashboardRecentOrdersTableSub: "قائمة سريعة بآخر الطلبات.",
    dashboardOpenOrders: "فتح الطلبات",
    dashboardTableOrder: "الطلب",
    dashboardTableClient: "العميل",
    dashboardTableDate: "التاريخ",
    dashboardTableStatus: "الحالة",
    dashboardTableTotal: "المجموع",
    dashboardPosJournal: "سجل المبيعات",
    dashboardPosJournalSub: "أحدث العمليات التي تمت عبر حسابات الصندوق.",
    dashboardOpenPos: "فتح نقطة البيع",
    dashboardNoPosLogs: "لا توجد سجلات بيع حالياً.",
    dashboardActionDetails: "تفاصيل العملية",
    dashboardClickActionDetails: "انقر فوق أي عملية لعرض تفاصيلها.",
    dashboardActionCaisse: "عملية بيع",
    dashboardClient: "العميل",
    dashboardInvoice: "الفاتورة",
    dashboardSplitInvoice: "فاتورة مجزأة",
    dashboardSimpleInvoice: "فاتورة بسيطة",
    dashboardSubtotal: "المجموع الفرعي",
    dashboardDiscount: "خصم",
    dashboardTotalPaid: "إجمالي المدفوع",
    dashboardInvoicesCreated: "الفواتير المنشأة",
    dashboardProducts: "المنتجات",
    dashboardMainProduct: "المنتج الأساسي",
    dashboardCompleteRawData: "البيانات الكاملة",
    dashboardCloseDetails: "إغلاق التفاصيل",
    prodTitle: "المنتجات",
    prodNewProduct: "منتج جديد",
    prodTotalStock: "إجمالي المخزون",
    prodPurchaseValue: "قيمة الشراء",
    prodSalesValue: "قيمة البيع",
    prodStockAlerts: "تنبيهات المخزون",
    prodTvaInvoice: "الضريبة على الفاتورة (%)",
    prodSave: "حفظ",
    prodAll: "الكل",
    prodSearch: "بحث",
    prodCategory: "الفئة",
    prodStatus: "الحالة",
    prodPerPage: "لكل صفحة",
    prodReset: "إعادة تعيين",
    prodBarcode: "الباركود",
    prodStock: "المخزون",
    prodPurchase: "شراء",
    prodPrice: "السعر",
    prodActions: "الإجراءات",
    prodCopy: "نسخ",
    prodModify: "تعديل",
    prodDelete: "حذف",
    prodNoProductFound: "لم يتم العثور على أي منتج.",
    prodFirst: "الأول",
    prodPrevious: "السابق",
    prodNext: "التالي",
    prodLast: "الأخير",
    prodEditProduct: "تعديل المنتج",
    prodCreateProduct: "منتج جديد",
    prodLoading: "جاري التحميل...",
    prodInfos: "المعلومات",
    prodMedia: "الوسائط",
    prodVariants: "الخيارات",
    prodStockTab: "المخزون",
    prodQuickCreation: "إنشاء سريع",
    prodChooseCategory: "اختر فئة...",
    prodSubcategory: "الفئة الفرعية",
    prodNone: "بلا فئة",
    prodProductName: "اسم المنتج *",
    prodBarcodePlaceholder: "توليد تلقائي إذا تركت فارغة، أو 12/13 رقماً",
    prodBarcodeHint: "فارغ = توليد باركود فريد تلقائياً.",
    prodShortDesc: "الوصف القصير",
    prodShortDescPlaceholder: "النص المعروض في بطاقة المنتج",
    prodDetailedDesc: "الوصف التفصيلي",
    prodPurchasePrice: "سعر الشراء *",
    prodSellingPrice: "سعر البيع *",
    prodPromoPrice: "سعر الترويج",
    prodImageUrl: "رابط الصورة",
    prodYoutubeUrl: "رابط يوتيوب",
    prodUploadImages: "تحميل الصور",
    prodUploadImagesHint: "الصور الحالية ستبقى. سيتم إضافة الصور الجديدة.",
    prodChooseMainImage: "اختر الصورة الأساسية.",
    prodMain: "أساسية",
    prodChoose: "اختر",
    prodExistingGallery: "المعرض الحالي",
    prodDefineMain: "تعيين كصورة أساسية",
    prodNoImageSaved: "لا توجد صور محفوظة لهذا المنتج.",
    prodVariantsSizes: "الخيارات / المقاسات",
    prodVariantsHint: "كل خيار له سعره وصورته ورمز الباركود الخاص به.",
    prodAddVariant: "إضافة خيار",
    prodVariantName: "الخيار (الاسم/المقاس)",
    prodVariantNamePlaceholder: "مثال: كبير، XL، أحمر...",
    prodNew: "جديد",
    prodNoVariants: "لا توجد خيارات",
    prodAddFirstVariant: "إضافة الخيار الأول",
    prodStockByDepot: "المخزون حسب المستودع",
    prodStockHint: "اختر المستودع، الرف والكمية المتوفرة.",
    prodAddLocation: "إضافة موقع مخزني",
    prodNewDepot: "مستودع جديد",
    prodNewDepotPlaceholder: "مستودع تونس مثلاً",
    prodAddDepot: "إضافة مستودع",
    prodDepot: "المستودع",
    prodNewLine: "رف/خط جديد",
    prodNewLinePlaceholder: "الرف ب / القسم 2",
    prodAddLine: "إضافة خط",
    prodChooseDepot: "اختر مستودعاً",
    prodChooseLine: "اختر خطاً/رفاً",
    prodQuantity: "الكمية",
    prodNoStockAdded: "لم يتم إدخال أي كمية مخزون",
    prodStockEmptyHint:
      "أضف موقعاً مخزنياً واحداً على الأقل لمتابعة كمية المنتج.",
    prodAddStock: "إضافة مخزون",
    prodCreateBtn: "إنشاء المنتج",
    prodCancel: "إلغاء",
    prodFermer: "إغلاق",
    yourCart: "سلة المشتريات الخاصة بك",
    browseProducts: "تصفح المنتجات",
    variant: "الخيار",
    calculatedLater: "سيتم حسابه لاحقاً",
    proceedToCheckout: "الذهاب للدفع",
    checkoutNote: "راجع تفاصيل السلة، ثم أكمل بياناتك لتأكيد الطلب.",
    checkoutSubtitle:
      "يرجى ملء معلومات الاتصال واختيار ما إذا كنت تريد عرض سعر أو طلباً مباشراً.",
    firstName: "الاسم الأول",
    lastName: "اللقب",
    devisQuestion: "هل تريد عرض سعر؟",
    directOrder: "طلب مباشر",
    requestDevis: "طلب عرض سعر",
    devisDetails: "تفاصيل إضافية لطلب عرض السعر (اختياري)",
    devisDetailsPlaceholder:
      "مثال: الكمية، وقت التسليم المفضل أو ملاحظات التعبئة...",
    deviceId: "معرّف الجهاز (مستعمل كـ MAC):",
    deviceIdNote:
      "هذا المعرّف مشفّر ويستخدم لحماية طلباتك ومنع إساءة الاستخدام.",
    sendingOrder: "جاري إرسال طلبك...",
    sendOrder: "تأكيد طلبي",
    sendQuoteRequest: "إرسال طلب عرض السعر",
    quoteFlowNote: "أنت بصدد إرسال طلب عرض سعر للكميات بالجملة.",
    orderError: "فشل في إرسال طلبك. يرجى المحاولة مرة أخرى.",
    checkoutSuccessOrderTitle: "تم إرسال طلبك بنجاح",
    checkoutSuccessQuoteTitle: "تم إرسال طلب عرض السعر بنجاح",
    checkoutSuccessOrderText:
      "استلمنا طلبك وسنتواصل معك قريباً لتأكيده وتفاصيله.",
    checkoutSuccessQuoteText:
      "استلمنا طلب عرض السعر وسنتواصل معك قريباً لإرسال التفاصيل.",
    checkoutSuccessNext: "ستعود إلى الصفحة الرئيسية خلال لحظات.",
    checkoutSuccessBackHome: "العودة إلى الرئيسية الآن",
    partnersTitle: "شركاؤنا",
    trustedNetwork: "شبكة موثوقة",
    partnersMainTitle: "شركاؤنا ومساعدونا",
    partnersSubtitle:
      "نحن نعمل مع علامات تجارية وشركات رائعة لتقديم تجارب ومنتجات أفضل.",
    partnersCount: "شركاء",
    qualityTitle: "الجودة",
    selectedBrands: "علامات تجارية مختارة",
    marquesSelectionnees: "علامات تجارية مختارة",
    collaborationDurable: "شراكة مستدامة",
    qualiteProduit: "جودة المنتجات",
    loadingPartners: "جاري تحميل الشركاء...",
    noPartners: "لا يوجد شركاء بعد. عد قريباً.",
    catalog: "الكتالوج",
    filtersLabel: "تصفية الكتالوج",
    allSubcategories: "جميع الفئات الفرعية",
    toutesSubcategories: "جميع الفئات الفرعية",
    productsShown: "منتج معروض",
    productsShownPlural: "منتجات معروضة",
    subcategoriesLabel: "فئات فرعية",
    subcategoriesLabelPlural: "فئات فرعية",
    allPrices: "جميع الأسعار",
    fromPrice: "ابتداءً من",
    toPrice: "إلى غاية",
    apply: "تطبيق",
    activeFilters: "الفلاتر النشطة",
    aucunProduit: "لم يتم العثور على أي منتج.",
    recharger: "إعادة التحميل",
    chargementSuivant: "جاري تحميل المنتجات التالية",
    finCollection: "نهاية المجموعة.",
  },
  en: {
    home: "Home",
    shop: "Shop",
    manasek: "Categories",
    partners: "Partners",
    admin: "Admin Panel",
    logout: "Logout",
    cartTitle: "Shopping Cart",
    cartCount: "items in cart",
    cartEmpty: "Your cart is empty",
    cartBrowse: "Browse the catalog and choose the products you need.",
    remove: "Remove",
    total: "Total",
    checkout: "Checkout",
    updatingCart: "Updating cart...",
    heroTitle: "All your products in one organized catalog",
    heroSubtitle:
      "Browse multiple product types by category, compare details, and send your order easily.",
    discoverOurProducts: "Discover Our Products",
    shopNow: "Shop Now",
    manasekProducts: "All Products",
    ourStory: "How It Works",
    ourStoryTitle: "A flexible catalog for multiple product lines",
    ourStoryDesc:
      "The storefront is built for any type of product: clear categories, organized cards, detailed product pages, and direct ordering without tying the site to one theme.",
    categories: "Categories",
    categoriesDesc:
      "Choose a category to view the products and options available inside it.",
    allProducts: "Shop All Products →",
    viewCategory: "View Category",
    viewAll: "View All",
    newArrivals: "New Arrivals",
    featuredProducts: "Featured Products",
    featuredDesc:
      "Selected products from the catalog based on recent additions and availability.",
    viewStore: "View Store →",
    ourPromise: "Our Promise",
    ourPromiseTitle: "An organized experience for any product type",
    ourPromiseDesc:
      "Each page is designed to present products clearly: images, prices, options, and details that help customers choose quickly.",
    discoverCollection: "Discover Full Collection",
    filters: "Categories",
    minPrice: "Min Price",
    maxPrice: "Max Price",
    applyFilters: "Apply Filters",
    resetFilters: "Reset Filters",
    addToCart: "Add to Cart",
    loadingProducts: "Loading products...",
    noProducts: "No matching products found.",
    sale: "Sale",
    searchPlaceholder: "Search for a product...",
    allCategories: "All Categories",
    inStock: "In Stock",
    outOfStock: "Out of Stock",
    quantity: "Quantity",
    description: "Description",
    specifications: "Specifications",
    size: "Size",
    priceOMR: "OMR",
    relatedProducts: "Related Products",
    videoPresentation: "Video Presentation",
    checkoutTitle: "Checkout Process",
    personalInfo: "Personal Information",
    fullName: "Full Name",
    phone: "Phone Number",
    email: "Email Address",
    address: "Shipping Address",
    city: "City",
    notes: "Order Notes (optional)",
    paymentMethod: "Payment Method",
    cashOnDelivery: "Cash on Delivery",
    creditCard: "Credit Card",
    orderSummary: "Order Summary",
    placeOrder: "Confirm Order",
    subtotal: "Subtotal",
    discount: "Discount",
    shipping: "Shipping",
    free: "Free",
    orderSuccess: "Order Placed Successfully!",
    orderSuccessDesc:
      "Thank you for choosing us. We will contact you shortly to confirm your order details.",
    backToHome: "Back to Home",
    adminTitle: "Admin Panel",
    adminDashboard: "Dashboard",
    adminProducts: "Products",
    adminCaisse: "Point of Sale",
    adminCategories: "Categories",
    adminCommandes: "Orders",
    adminClients: "Clients",
    adminUsers: "Users",
    adminPaniers: "Carts",
    adminPartners: "Partners",
    adminAppearance: "Theme & Slider",
    adminFooter: "Footer",
    adminVisits: "Visitor analytics",
    dashboardPerformance: "Store Performance",
    dashboardSubtitle: "{accepted} orders accepted out of {total} in total.",
    dashboardConfirmedRevenue: "Confirmed Revenue",
    dashboardAcceptanceRate: "Acceptance Rate",
    dashboardThisMonth: "This Month",
    dashboardMostDemanded: "Most Demanded Product",
    dashboardPiecesRequested: "{count} pieces requested",
    dashboardPendingPotential: "Pending Potential",
    dashboardWaitingOrders: "{count} waiting orders",
    dashboardAcceptedOrders: "{count} accepted orders",
    dashboardTotalOrders: "Total Orders",
    dashboardRefused: "refused",
    dashboardDemandedPieces: "Demanded Pieces",
    dashboardActiveProductsCount: "{count} active products",
    dashboardOrderStatus: "Order Status",
    dashboardStatusSub: "Revenue and volume by status.",
    dashboardRecentOrders: "Recent Orders",
    dashboardRecentActivity: "Recent activity.",
    dashboardNoRecentOrders: "No recent orders.",
    dashboardProductPerf: "Products Performance",
    dashboardProductPerfSub: "Accepted revenue, pending potential, and demand.",
    dashboardSearchPlaceholder: "Search product...",
    dashboardSold: "sold",
    dashboardRequested: "requested",
    dashboardPending: "pending",
    dashboardRevenue: "Revenue",
    dashboardDemand: "Demand",
    dashboardNoProductAnalytics: "No product analytics found.",
    dashboardRecentOrdersTable: "Recent Orders",
    dashboardRecentOrdersTableSub: "Quick list of recent orders.",
    dashboardOpenOrders: "Open Orders",
    dashboardTableOrder: "Order",
    dashboardTableClient: "Client",
    dashboardTableDate: "Date",
    dashboardTableStatus: "Status",
    dashboardTableTotal: "Total",
    dashboardPosJournal: "POS Journal",
    dashboardPosJournalSub: "Recent actions performed by POS accounts.",
    dashboardOpenPos: "Open Point of Sale",
    dashboardNoPosLogs: "No POS logs yet.",
    dashboardActionDetails: "Action Details",
    dashboardClickActionDetails: "Click on an action to view its details.",
    dashboardActionCaisse: "POS Action",
    dashboardClient: "Client",
    dashboardInvoice: "Invoice",
    dashboardSplitInvoice: "Split Invoice",
    dashboardSimpleInvoice: "Simple Invoice",
    dashboardSubtotal: "Subtotal",
    dashboardDiscount: "Discount",
    dashboardTotalPaid: "Total Paid",
    dashboardInvoicesCreated: "Invoices Created",
    dashboardProducts: "Products",
    dashboardMainProduct: "Main Product",
    dashboardCompleteRawData: "Complete Raw Data",
    dashboardCloseDetails: "Close Details",
    prodTitle: "Products",
    prodNewProduct: "New Product",
    prodTotalStock: "Total Stock",
    prodPurchaseValue: "Purchase Value",
    prodSalesValue: "Sales Value",
    prodStockAlerts: "Stock Alerts",
    prodTvaInvoice: "Invoice VAT (%)",
    prodSave: "Save",
    prodAll: "All",
    prodSearch: "Search",
    prodCategory: "Category",
    prodStatus: "Status",
    prodPerPage: "Per page",
    prodReset: "Reset",
    prodBarcode: "Barcode",
    prodStock: "Stock",
    prodPurchase: "Purchase",
    prodPrice: "Price",
    prodActions: "Actions",
    prodCopy: "Copy",
    prodModify: "Edit",
    prodDelete: "Delete",
    prodNoProductFound: "No product found with these filters.",
    prodFirst: "First",
    prodPrevious: "Previous",
    prodNext: "Next",
    prodLast: "Last",
    prodEditProduct: "Edit Product",
    prodCreateProduct: "New Product",
    prodLoading: "Loading...",
    prodInfos: "Info",
    prodMedia: "Media",
    prodVariants: "Variants",
    prodStockTab: "Stock",
    prodQuickCreation: "Quick Creation",
    prodChooseCategory: "Choose category...",
    prodSubcategory: "Subcategory",
    prodNone: "None",
    prodProductName: "Product Name *",
    prodBarcodePlaceholder: "Auto if empty, or 12/13 digits",
    prodBarcodeHint: "Empty = unique barcode auto-generation.",
    prodShortDesc: "Short Description",
    prodShortDescPlaceholder: "Text displayed on the product card",
    prodDetailedDesc: "Detailed Description",
    prodPurchasePrice: "Purchase Price *",
    prodSellingPrice: "Selling Price *",
    prodPromoPrice: "Sale Price",
    prodImageUrl: "Image URL",
    prodYoutubeUrl: "YouTube Link",
    prodUploadImages: "Upload Images",
    prodUploadImagesHint:
      "Existing images will remain. New ones will be added.",
    prodChooseMainImage: "Choose the main image.",
    prodMain: "Main",
    prodChoose: "Select",
    prodExistingGallery: "Existing Gallery",
    prodDefineMain: "Set as main",
    prodNoImageSaved: "No images saved for this product.",
    prodVariantsSizes: "Variants / Sizes",
    prodVariantsHint: "Each variant has its own price, image, and barcode.",
    prodAddVariant: "Add Variant",
    prodVariantName: "Variant (Name/Size)",
    prodVariantNamePlaceholder: "e.g. L, XL, Red...",
    prodNew: "New",
    prodNoVariants: "No variants",
    prodAddFirstVariant: "Add first variant",
    prodStockByDepot: "Stock by Warehouse",
    prodStockHint: "Choose warehouse, shelf/line, and quantity.",
    prodAddLocation: "Add Location",
    prodNewDepot: "New Warehouse",
    prodNewDepotPlaceholder: "e.g. Warehouse Tunis",
    prodAddDepot: "Add Warehouse",
    prodDepot: "Warehouse",
    prodNewLine: "New Line/Shelf",
    prodNewLinePlaceholder: "e.g. Row B / Shelf 2",
    prodAddLine: "Add Line",
    prodChooseDepot: "Choose warehouse",
    prodChooseLine: "Choose line",
    prodQuantity: "Quantity",
    prodNoStockAdded: "No stock records",
    prodStockEmptyHint: "Add at least one location to track inventory.",
    prodAddStock: "Add Stock",
    prodCreateBtn: "Create Product",
    prodCancel: "Cancel",
    prodFermer: "Close",
    yourCart: "Your cart",
    browseProducts: "Browse products",
    variant: "Variant",
    calculatedLater: "Calculated later",
    proceedToCheckout: "Proceed to checkout",
    checkoutNote:
      "Review your cart, then enter your details to confirm your order.",
    checkoutSubtitle:
      "Fill in your contact details and choose whether you want a quote or a direct order.",
    firstName: "First name",
    lastName: "Last name",
    devisQuestion: "Do you want a quote?",
    directOrder: "Direct order",
    requestDevis: "Request a quote",
    devisDetails: "Additional quote details (optional)",
    devisDetailsPlaceholder:
      "For example: quantity, preferred delivery time, or packaging notes...",
    deviceId: "Device ID (used as MAC):",
    deviceIdNote:
      "This identifier is hashed and used to protect your orders and prevent abuse.",
    sendingOrder: "Sending your order...",
    sendOrder: "Confirm My Order",
    sendQuoteRequest: "Send quote request",
    quoteFlowNote: "You are requesting a wholesale quote.",
    orderError: "Failed to send your order. Please try again.",
    checkoutSuccessOrderTitle: "Your order has been sent",
    checkoutSuccessQuoteTitle: "Your quote request has been sent",
    checkoutSuccessOrderText:
      "We received your order and will contact you shortly to confirm the details.",
    checkoutSuccessQuoteText:
      "We received your quote request and will contact you shortly with the details.",
    checkoutSuccessNext: "You will return to the home page in a few seconds.",
    checkoutSuccessBackHome: "Back to home now",
    partnersTitle: "Our Partners",
    trustedNetwork: "Trusted network",
    partnersMainTitle: "Our Partners & Collaborators",
    partnersSubtitle:
      "We work together with amazing brands and companies to deliver better experiences and products.",
    partnersCount: "Partners",
    qualityTitle: "Quality",
    selectedBrands: "Selected brands",
    marquesSelectionnees: "Selected brands",
    collaborationDurable: "Sustainable partnership",
    qualiteProduit: "Product quality",
    loadingPartners: "Loading partners...",
    noPartners: "No partners yet. Come back soon.",
    catalog: "Catalog",
    filtersLabel: "Catalog Filters",
    allSubcategories: "All Subcategories",
    toutesSubcategories: "All subcategories",
    productsShown: "product shown",
    productsShownPlural: "products shown",
    subcategoriesLabel: "subcategory",
    subcategoriesLabelPlural: "subcategories",
    allPrices: "All prices",
    fromPrice: "Starting from",
    toPrice: "Up to",
    apply: "Apply",
    activeFilters: "Active filters",
    aucunProduit: "No products found.",
    recharger: "Reload",
    chargementSuivant: "Loading next products",
    finCollection: "End of collection.",
  },
};
const productTranslations = {
  "منتجات مناسك": "Manasek Hajj Products",
  "منتجات Orkidor": "Orkidor Beauty",
  "عناية بالبشرة": "Skincare",
  "حماية من الشمس": "Sun Protection",
  "عناية بالشعر": "Haircare",
  "عناية بالجسم": "Body Care",
  "تنظيف ونظافة": "Cleansing & Hygiene",
  "ترطيب وتفتيح": "Moisturizing & Brightening",
  "حماية وعلاج": "Protection & Treatment",
  "لوشن منشّط للبشرة": "Energizing Body Lotion",
  "سيروم تفتيح مركز": "Concentrated Brightening Serum",
  "كريم تفتيح": "Brightening Cream",
  "واقي شمس معدني غير مرئي +SPF 50 لجميع أنواع البشرة":
    "Invisible Mineral Sunscreen SPF 50+ for All Skin Types",
  "جل تنظيف الوجه": "Face Cleansing Gel",
  "منظف الوجه للبشرة الحساسة": "Sensitive Skin Face Cleanser",
  "بخاخ منــــاسك المهدئ للوجه": "Manasek Soothing Face Mist",
  "واقي الشمس مناسك المعدني و الخالي من العطور":
    "Manasek Mineral Sunscreen, Fragrance-Free",
  "كريم الرجال واقي الشمس للرقبة والكتفين":
    "Men's Sunscreen Cream for Neck & Shoulders",
  "شامبو مناسك الخالي من العطور 100 مل": "Manasek Fragrance-Free Shampoo 100ml",
  "شامبو مناسك الخالي من العطور 200 مل": "Manasek Fragrance-Free Shampoo 200ml",
  "جال استحمام مناسك الخالي من العطور 200 مل":
    "Manasek Fragrance-Free Shower Gel 200ml",
  "كريم مناسك المضاد للمتهيجات و الخالي من العطور":
    "Manasek Anti-Irritation Cream, Fragrance-Free",
  "ديو مناسك المضاد للتعرق و الخالي من العطور":
    "Manasek Fragrance-Free Antiperspirant Deodorant",
  "الرغوة الخاصة بالمناطق الحساسة من مناسك": "Manasek Sensitive Area Foam",
  "صابون طبيعي صلب للوجه و الجسم": "Natural Solid Soap for Face & Body",
  "معجون اسنان مناسك المطهر و الخالي من العطور":
    "Manasek Antiseptic Fragrance-Free Toothpaste",
  "الصابون السائل مناسك الخالي من العطور 200 مل":
    "Manasek Fragrance-Free Liquid Soap 200ml",
  "بخاخ مناسك المضاد للفطريات و الخالي من العطور":
    "Manasek Antifungal Spray, Fragrance-Free",
  "لوشن منشّط للبشرة يمنحها الترطيب والحيوية طوال اليوم. مناسب لجميع أنواع البشرة. تركيبة لطيفة خالية من المواد الضارة.":
    "Energizing body lotion that gives the skin hydration and vitality all day long. Suitable for all skin types. Gentle formula free from harmful substances.",
  "لوشن منشّط ومرطّب للبشرة لاستخدام يومي":
    "Daily energizing and moisturizing body lotion",
  "سيروم تفتيح مركّز يعمل على توحيد لون البشرة وتخفيف البقع الداكنة. تركيبة متطورة بفعالية عالية.":
    "Concentrated brightening serum that works to even out skin tone and reduce dark spots. Advanced, high-efficacy formula.",
  "سيروم مركّز لتفتيح البشرة وتوحيد لونها":
    "Concentrated serum for skin brightening and tone evening",
  "كريم تفتيح يجمع بين الترطيب العميق وتوحيد لون البشرة. مناسب للاستخدام اليومي صباحاً ومساءً.":
    "Brightening cream combining deep hydration and skin tone evening. Suitable for daily morning and evening use.",
  "كريم مرطّب ومفتّح للبشرة بتركيبة فعّالة":
    "Moisturizing and brightening cream with effective formula",
  "واقي شمس معدني بمعامل حماية SPF 50+ لجميع أنواع البشرة. تركيبة شفافة غير مرئية على البشرة، تحمي من أشعة UV دون بقع بيضاء.":
    "Mineral sunscreen with SPF 50+ protection for all skin types. Lightweight transparent formula, invisible on the skin, protecting from UV rays without leaving white marks.",
  "واقي شمس معدني خفيف الوزن غير مرئي بحماية عالية":
    "Lightweight invisible mineral sunscreen with high protection",
  "جل تنظيف الوجه من مناسك مصمّم خصيصاً لحجاج بيت الله الكرام. خالٍ من العطور والمواد الضارة، ينظّف البشرة بلطف ويرطّبها.":
    "Manasek face cleansing gel specifically designed for pilgrims. Fragrance-free and free from harmful substances, it gently cleanses and hydrates the skin.",
  "جل تنظيف لطيف للوجه خالٍ من العطور — مناسب للمحرم":
    "Gentle face cleansing gel, fragrance-free — ihram-safe",
  "منظف الوجه للبشرة الحساسة من مناسك. تركيبة مطوّرة لا تحتوي على عطور أو كحول، تحافظ على الحاجز الطبيعي للبشرة. مناسب لفترة الإحرام.":
    "Manasek sensitive skin face cleanser. An advanced formula free from fragrance or alcohol, preserving the natural skin barrier. Ideal for the Ihram period.",
  "منظّف لطيف خصّيصاً للبشرة الحساسة — خالٍ من العطور":
    "Gentle cleanser specifically for sensitive skin — fragrance-free",
  "بخاخ مناسك المهدئ للوجه يمنح الترطيب الفوري ويهدئ البشرة المتعبة خلال رحلة الحج والعمرة. خالٍ من العطور ومناسب للمحرم.":
    "Manasek soothing face mist provides instant hydration and soothes tired skin during Hajj and Umrah. Fragrance-free and suitable for the pilgrim.",
  "بخاخ مهدّئ ومرطّب للوجه — خالٍ من العطور، مناسب للإحرام":
    "Soothing & hydrating face mist — fragrance-free, ihram-compatible",
  "واقي الشمس مناسك المعدني مصنوع خصيصاً لحجاج بيت الله، خالٍ تماماً من العطور والكحول. يوفر حماية فعّالة من أشعة الشمس خلال رحلة الحج والعمرة.":
    "Manasek mineral sunscreen specifically made for pilgrims, completely fragrance-free and alcohol-free. Provides effective protection from the sun during Hajj and Umrah.",
  "واقي شمس معدني خالٍ من العطور — مناسب للإحرام":
    "Mineral sunscreen, fragrance-free — ihram-compatible",
  "كريم واقي شمس مخصص للرجال، مصمم لحماية الرقبة والكتفين المعرّضة للشمس أثناء أداء مناسك الحج. خالٍ من العطور.":
    "Sunscreen cream dedicated to men, designed to protect the neck and shoulders exposed to the sun during Hajj. Fragrance-free.",
  "واقي شمس للرجال مخصص للرقبة والكتفين — مناسب للإحرام":
    "Men's sunscreen for neck & shoulders — ihram-compatible",
  "شامبو مناسك الخالي من العطور بحجم 100مل مثالي للسفر. ينظّف الشعر بلطف دون عطور أو كحول. مناسب لاستخدام المحرم.":
    "Manasek fragrance-free shampoo in travel size (100ml). Gently cleanses hair without fragrances or alcohol. Suitable for Ihram.",
  "شامبو خالٍ من العطور حجم السفر — مناسب للإحرام":
    "Fragrance-free shampoo travel size — ihram-compatible",
  "شامبو مناسك الخالي من العطور بحجم 200مل للاستخدام اليومي. ينظّف الشعر بلطف ويحافظ على صحته دون أي عطور أو مواد مزعجة.":
    "Manasek fragrance-free shampoo in full size (200ml) for daily use. Gently cleanses and maintains hair health without any fragrances or irritants.",
  "شامبو خالٍ من العطور الحجم الكامل — مناسب للإحرام":
    "Fragrance-free shampoo full size — ihram-compatible",
  "جال استحمام مناسك الخالي من العطور ينظّف الجسم بلطف مع الحفاظ على رطوبة البشرة. تركيبة خالية من العطور ومناسبة لفترة الإحرام.":
    "Manasek fragrance-free shower gel gently cleanses the body while preserving skin moisture. Fragrance-free formula suitable for the Ihram period.",
  "جال استحمام لطيف خالٍ من العطور — مناسب للإحرام":
    "Gentle fragrance-free shower gel — ihram-compatible",
  "كريم مناسك المضاد للمتهيجات يعالج ويهدئ التهيجات الجلدية الناتجة عن الحرارة والاحتكاك خلال مناسك الحج. خالٍ من العطور والكحول.":
    "Manasek anti-irritation cream treats and soothes skin irritations caused by heat and friction during Hajj rituals. Fragrance-free and alcohol-free.",
  "كريم مضاد للتهيجات الجلدية — خالٍ من العطور، مناسب للإحرام":
    "Anti-skin-irritation cream — fragrance-free, ihram-compatible",
  "ديو مناسك المضاد للتعرق مصمّم للحجاج والمعتمرين. يوفر حماية فعّالة من التعرق دون عطور. التزامٌ بأحكام الإحرام.":
    "Manasek antiperspirant deodorant designed for pilgrims. Provides effective protection from sweat without fragrance, adhering to Ihram rules.",
  "مضاد للتعرق خالٍ من العطور — مناسب للإحرام":
    "Antiperspirant deodorant, fragrance-free — ihram-compatible",
  "رغوة مناسك المخصصة للمناطق الحساسة توفر تنظيفاً لطيفاً وفعّالاً. تركيبة ملائمة للبشرة الحساسة وخالية من العطور.":
    "Manasek cleansing foam for sensitive areas provides gentle and effective cleansing. Suitable formula for sensitive skin, fragrance-free.",
  "رغوة تنظيف لطيفة للمناطق الحساسة — خالية من العطور":
    "Gentle cleansing foam for sensitive areas — fragrance-free",
  "صابون طبيعي صلب من مناسك مصنوع من مكوّنات طبيعية. مناسب للوجه والجسم معاً، خالٍ من العطور الاصطناعية، مناسب للاستخدام أثناء الإحرام.":
    "Manasek natural solid soap made from natural ingredients. Suitable for both face and body, free from synthetic fragrances, and suitable for Ihram.",
  "صابون طبيعي صلب للوجه والجسم — خالٍ من العطور":
    "Natural solid soap for face & body — fragrance-free",
  "معجون أسنان مناسك المطهر خالٍ من العطور والنكهات الاصطناعية. ينظّف الأسنان ويحافظ على صحة الفم مع الالتزام بأحكام الإحرام.":
    "Manasek antiseptic toothpaste, free from fragrances and synthetic flavors. Cleanses teeth and maintains oral health while respecting Ihram rules.",
  "معجون أسنان مطهّر خالٍ من العطور — مناسب للإحرام":
    "Antiseptic toothpaste, fragrance-free — ihram-compatible",
  "الصابون السائل من مناسك بحجم 200مل ينظّف اليدين والجسم بلطف. خالٍ من العطور والكحول، مثالي للحجاج والمعتمرين.":
    "Manasek liquid soap (200ml) gently cleanses hands and body. Fragrance-free and alcohol-free, ideal for pilgrims.",
  "صابون سائل لطيف خالٍ من العطور — مناسب للإحرام":
    "Gentle liquid soap, fragrance-free — ihram-compatible",
  "بخاخ مناسك المضاد للفطريات يحمي القدمين والمناطق الحساسة من الفطريات خلال رحلة الحج. خالٍ تماماً من العطور.":
    "Manasek antifungal spray protects feet and sensitive areas from fungus during Hajj. Completely fragrance-free.",
  "بخاخ مضاد للفطريات — خالٍ من العطور، مناسب للإحرام":
    "Antifungal spray — fragrance-free, ihram-compatible",
  "100 مل": "100ml",
  "200 مل": "200ml",
  "30 مل": "30ml",
  "50 مل": "50ml",
  "150 مل": "150ml",
  "75 مل": "75ml",
  "100 غ": "100g",
  "200 غ": "200g",
};
export { translations, productTranslations };
